import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class TransactionDetailColumnAdjustService {
    private initialColumns : any;

    constructor(
    ) { }

    public setInitialColumn(column: any) {
        this.initialColumns = column;
    }

    public getInitialColumn() {
        return this.initialColumns;
    }

    drop(event: CdkDragDrop<any[]>, columns: any[], tranactionType: string): void {
      // Prevent dropping if it involves the stock column
        if (columns[event.previousIndex].key !== 'stock' && columns[event.currentIndex].key !== 'stock') {
          moveItemInArray(columns, event.previousIndex, event.currentIndex);
          this.saveColumnOrder(columns, tranactionType);
        }
      }
    
      saveColumnOrder(columns: any[], tranactionType: string) {
        const orderObj = columns.reduce((acc, col, index) => {
          acc[col.key] = index;
          return acc;
        }, {} as Record<string, number>);
        localStorage.setItem(tranactionType, JSON.stringify(orderObj));
      }
    
      loadColumnOrder(tranactionType: string): Record<string, number> | null {
        const savedOrder = localStorage.getItem(tranactionType);
        return savedOrder ? JSON.parse(savedOrder) : null;
      }
    
      resetColumnOrder(tranactionType: string) {
        localStorage.removeItem(tranactionType);
      
      }


}